import React from 'react'
import { Button } from 'primereact/button'

import useText from '../hooks/useText'

interface IComponentProps {
    emptyText?: string
    isFetching?: boolean
    action?: () => void
    label?: string
    icon?: React.ReactElement
}

const EmptyListRefresh = ({ isFetching, emptyText, action, icon, label }: IComponentProps) => {
    const text = useText()
    return (
        <div className="flex flex-auto flex-column justify-content-center align-items-center h-12rem gap-2 surface-50 text-600 font-bold">
            {action && !isFetching ? (
                <>
                    <span>{emptyText}</span>
                    <Button
                        type="button"
                        label={label ? label : text('btnRefresh')}
                        onClick={() => action()}
                        icon={icon ?? 'pi pi-refresh'}
                    />
                </>
            ) : (
                <div className="shimmer-container shimmer-small"></div>
            )}
        </div>
    )
}

export default EmptyListRefresh
